export function formatarTelefone(telefone) {
  const digitos = String(telefone || "");
  const match = digitos.match(/^55(\d{2})(\d{4,5})(\d{4})$/);
  if (!match) return digitos;
  return `(${match[1]}) ${match[2]}-${match[3]}`;
}

export function motivoParaNaoExcluir(telefone) {
  if (telefone.conversas > 0) {
    return "Já conversou com o agente. Inative em vez de excluir.";
  }
  if (telefone.rotinas?.length) {
    return `Recebe relatórios de ${telefone.rotinas.map((r) => r.name).join(", ")}. Tire-o das rotinas antes.`;
  }
  return "";
}

export function diffDeLinhas(antes, depois) {
  const a = (antes || "").split("\n");
  const b = (depois || "").split("\n");
  const tabela = Array.from({ length: a.length + 1 }, () =>
    new Array(b.length + 1).fill(0)
  );
  for (let i = a.length - 1; i >= 0; i -= 1) {
    for (let j = b.length - 1; j >= 0; j -= 1) {
      tabela[i][j] =
        a[i] === b[j]
          ? tabela[i + 1][j + 1] + 1
          : Math.max(tabela[i + 1][j], tabela[i][j + 1]);
    }
  }
  const linhas = [];
  let i = 0;
  let j = 0;
  while (i < a.length && j < b.length) {
    if (a[i] === b[j]) {
      linhas.push({ tipo: "igual", texto: a[i] });
      i += 1;
      j += 1;
    } else if (tabela[i + 1][j] >= tabela[i][j + 1]) {
      linhas.push({ tipo: "saiu", texto: a[i] });
      i += 1;
    } else {
      linhas.push({ tipo: "entrou", texto: b[j] });
      j += 1;
    }
  }
  while (i < a.length) {
    linhas.push({ tipo: "saiu", texto: a[i] });
    i += 1;
  }
  while (j < b.length) {
    linhas.push({ tipo: "entrou", texto: b[j] });
    j += 1;
  }
  return linhas;
}

export function comContexto(linhas, contexto = 2) {
  const perto = linhas.map(() => false);
  linhas.forEach((linha, indice) => {
    if (linha.tipo === "igual") return;
    const inicio = Math.max(0, indice - contexto);
    const fim = Math.min(linhas.length - 1, indice + contexto);
    for (let k = inicio; k <= fim; k += 1) perto[k] = true;
  });
  const saida = [];
  let omitidas = 0;
  linhas.forEach((linha, indice) => {
    if (perto[indice]) {
      if (omitidas) saida.push({ tipo: "omitidas", quantidade: omitidas });
      omitidas = 0;
      saida.push(linha);
    } else {
      omitidas += 1;
    }
  });
  if (omitidas) saida.push({ tipo: "omitidas", quantidade: omitidas });
  return saida;
}
